import { Box, Flex, Pagination } from '@lego/klik-ui';
import type { ChangeEvent } from 'react';

type TablePaginationProps = {
  contentPaddingX: number | number[];
  pageCount: number;
  pageIndex: number;
  pageSize: number;
  setPageIndex: (index: number) => void;
  setPagination: (pagination: { pageIndex: number; pageSize: number }) => void;
};

export const TablePagination = ({
  contentPaddingX,
  pageCount,
  pageIndex,
  pageSize,
  setPageIndex,
  setPagination,
}: TablePaginationProps) => (
  <Flex
    alignItems="center"
    gap={4}
    justifyContent="flex-end"
    left="0"
    mt={4}
    paddingX={contentPaddingX}
    position="sticky"
    right="0"
    width="100%"
  >
    {pageCount > 1 && (
      <Pagination
        onPageClick={(page: number) => setPageIndex(page - 1)}
        page={pageIndex + 1}
        totalPages={pageCount}
      />
    )}
    <Box
      as="select"
      backgroundColor="white"
      border="1px solid"
      borderColor="slate.200"
      borderRadius="md"
      color="slate.600"
      cursor="pointer"
      fontSize="sm"
      onChange={(e: ChangeEvent<HTMLSelectElement>) =>
        setPagination({ pageIndex: 0, pageSize: Number(e.target.value) })
      }
      paddingX={2}
      paddingY={1}
      value={pageSize}
    >
      {[15, 25, 50, 100].map((size) => (
        <option key={size} value={size}>
          {size} / page
        </option>
      ))}
    </Box>
  </Flex>
);
